import {
  isCnpj,
  isCpf,
  isCpfOrCnpj,
  normalizeDocument,
} from '../shared/documents';

export const docValidator = (doc: string) => {
  const normalized = normalizeDocument(doc);
  if (normalized.length === 11) return isCpf(normalized);
  if (normalized.length === 14) return isCnpj(normalized);
  return false;
};

export function validateCPF(value: string): boolean {
  return isCpf(value);
}

export function validateCNPJ(cnpj: string): boolean {
  return isCnpj(cnpj);
}

export { isCnpj, isCpf, isCpfOrCnpj };
